import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

const Text = styled.span`
  position: relative;
`;

const Label = styled.label`
  padding: 8px 15px;
  position: relative;
  font-size: 16px;
  color: white;
  border-radius: 5px;
  border: 1px solid #715aff;
  background-color: #715aff;
  cursor: pointer;

  &::before {
    content: '';
    width: 0;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0;
    border-radius: 4px;
    background-color: #403788;
    transition: all 0.3s;
  }

  &:hover::before {
    opacity: 1;
    width: 100%;
  }

  ${(props) =>
    props.outline &&
    css`
      color: #242424;
      background-color: #ffffff;

      &:hover {
        color: #ffffff;
      }

      &::before {
        border-radius: 0;
        background-color: #715aff;
      }
    `}
`;

const Input = styled.input`
  width: 0;
  height: 0;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;

  &:focus + ${Label} {
    background-color: red;
  }
`;

const FileInput = ({
  id,
  name,
  label = 'Upload file',
  accept = '',
  outline = false,
  onChange,
}) => (
  <div>
    <Input
      type="file"
      id={id}
      name={name}
      accept={accept}
      onChange={onChange}
    />
    <Label htmlFor={id} outline={outline}>
      <Text>{label}</Text>
    </Label>
  </div>
);

FileInput.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  accept: PropTypes.string,
  outline: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
};

export default FileInput;
